/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChangeScholarshipFileApprovalStatusRequestViewModel } from "../types/ChangeScholarshipFileApprovalStatusRequestViewModel.ts";
import { eScholarshipTypeStudentFileApprovalStatusSchema } from "./eScholarshipTypeStudentFileApprovalStatusSchema.ts";

export const changeScholarshipFileApprovalStatusRequestViewModelSchema =
  z.object({
    scholarshipTypeFileId: z.optional(
      z
        .number()
        .int()
        .describe(
          "ID do tipo de documento a avaliar. Vem de typeFiles[].scholarshipTypeFileId do dossiê. Obrigatório.",
        ),
    ),
    status: z.optional(
      z
        .lazy(() => eScholarshipTypeStudentFileApprovalStatusSchema)
        .describe(
          "0 = PendingAnswerFromTeam | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
        ),
    ),
    rejectionReason: z
      .string()
      .describe(
        "Justificativa da reprova. Obrigatória quando o status é Rejected; ignorada nos demais status.",
      )
      .nullish(),
    courseFinancialPersonId: z.optional(
      z
        .number()
        .int()
        .describe(
          "ID do plano financeiro do aluno. Define de quem é o documento e qual plano tem o status geral recalculado. O aluno é derivado da matrícula do plano. Obrigatório.",
        ),
    ),
  }) as unknown as ToZod<ChangeScholarshipFileApprovalStatusRequestViewModel>;
